import React, { useState, useRef } from 'react';
import { Upload, Play, Pause, Music2 } from 'lucide-react';
import { AppContext } from '../AppContext';

export default function AudioUploader() {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef<HTMLAudioElement>(null);
  const { input: audioFile, setInput: setAudioFile } = React.useContext(AppContext);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file && file.type.startsWith('audio/')) {
      setAudioFile(file);
    }
  };

  const audioFileUrl = () => {
    let result;

    if( !audioFile ) {
      result = ''
    }
    else {
      result =  URL.createObjectURL(audioFile as File)
    } 
    console.log( 'audio file url:', result)
    return result
 
  }
  const togglePlay = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center w-full h-full bg-gray-50 p-8">
      <div className="w-full max-w-md">
        <div className="mb-8 text-center">
          <h2 className="text-2xl font-bold text-gray-800 mb-2">Audio Upload</h2>
          <p className="text-gray-600">Upload and play your audio files</p>
        </div>

        <div className="bg-white rounded-lg shadow-md p-6">
          <label className="flex flex-col items-center justify-center w-full h-32 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 transition-colors">
            <div className="flex flex-col items-center justify-center pt-5 pb-6">
              <Upload className="w-10 h-10 mb-3 text-gray-400" />
              <p className="mb-2 text-sm text-gray-500">
                <span className="font-semibold">Click to upload</span> or drag and drop
              </p>
              <p className="text-xs text-gray-500">Audio files (MP3, WAV)</p>
            </div>
            <input
              type="file"
              className="hidden"
              accept="audio/*"
              onChange={handleFileChange}
            />
          </label>

          {audioFile && (
            <div className="mt-6">
              <div className="flex items-center justify-between bg-gray-100 p-4 rounded-lg">
                <div className="flex items-center space-x-3">
                  <Music2 className="w-5 h-5 text-gray-600" />
                  <span className="text-sm font-medium text-gray-700 truncate">
                    { (audioFile instanceof File )&& audioFile.name }
                  </span>
                </div>
                <button
                  onClick={togglePlay}
                  className="p-2 rounded-full hover:bg-gray-200 transition-colors"
                >
                  {isPlaying ? (
                    <Pause className="w-5 h-5 text-gray-600" />
                  ) : (
                    <Play className="w-5 h-5 text-gray-600" />
                  )}
                </button>
              </div>
              <audio controls
                ref={audioRef}
                className="hidden"
                onEnded={() => setIsPlaying(false)}
              >
                  <source src={audioFileUrl()} type="audio/mp3"/>
              </audio>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}